var TARGETING_DIRECTIVES = ["store_whitelist", "store_blacklist"];
var normalizeStoreCode = storeCode => typeof storeCode === "string" ? storeCode.trim().toLowerCase() : "";
var isTargetingKey = key => typeof key === "string" && key.trim().toLowerCase().startsWith("store_");
var toTargetingDirective = (key, value) => {
  var normalizedKey = key.trim().replace(/\|+$/, "");
  var normalizedValue = typeof value === "string" ? value.replace(/^\|+/, "") : "";
  return "".concat(normalizedKey, "||").concat(normalizedValue);
};
var getTargetingMetadata = offer => {
  var flattenedMetadata = Object.entries(offer || {}).filter(_ref => {
    var [key] = _ref;
    return isTargetingKey(key);
  }).map(_ref2 => {
    var [key, value] = _ref2;
    return toTargetingDirective(key, value);
  });
  if (flattenedMetadata.length > 0) {
    return flattenedMetadata.join("\n");
  }
  var publishedOfferDetails = Object.values((offer === null || offer === void 0 ? void 0 : offer.additional_data) || {}).filter(detail => isTargetingKey(detail === null || detail === void 0 ? void 0 : detail.key)).map(detail => toTargetingDirective(detail.key, detail.value));
  if (publishedOfferDetails.length > 0) {
    return publishedOfferDetails.join("\n");
  }

  // Also accept the directive in coupon_details for API variants which expose
  // Published Offer Details as a single text field.
  return offer === null || offer === void 0 ? void 0 : offer.coupon_details;
};
var parseTargetingMetadata = details => {
  if (details == null || details === "") {
    return {
      type: null,
      storeCodes: []
    };
  }
  if (typeof details !== "string") {
    return {
      error: "Published Offer Details must be text"
    };
  }
  var directives = [];
  var lines = details.split(/\r?\n/);
  var _loop = function () {
      var trimmedLine = line.trim();
      var targetingKey = TARGETING_DIRECTIVES.find(key => trimmedLine.toLowerCase().startsWith(key));
      if (!targetingKey) {
        if (trimmedLine.toLowerCase().startsWith("store_")) {
          return {
            v: {
              error: "Unsupported store targeting directive: ".concat(trimmedLine)
            }
          };
        }
        return 0; // continue
      }
      var match = trimmedLine.match(/^(store_whitelist|store_blacklist)\s*\|\|\s*([^|]+)$/i);
      if (!match) {
        return {
          v: {
            error: "Malformed store targeting directive: ".concat(trimmedLine)
          }
        };
      }
      var storeCodes = match[2].split(",").map(normalizeStoreCode);
      if (storeCodes.some(code => !code)) {
        return {
          v: {
            error: "Store targeting directive contains an empty store code: ".concat(trimmedLine)
          }
        };
      }
      directives.push({
        type: match[1].toLowerCase(),
        storeCodes
      });
    },
    _ret;
  for (var line of lines) {
    _ret = _loop();
    if (_ret === 0) continue;
    if (_ret) return _ret.v;
  }
  if (directives.length === 0) {
    return {
      type: null,
      storeCodes: []
    };
  }
  if (directives.length > 1) {
    return {
      error: "Published Offer contains multiple store targeting directives"
    };
  }
  return directives[0];
};
export var getOfferStoreAvailability = (offer, storeCode) => {
  var targeting = parseTargetingMetadata(getTargetingMetadata(offer));
  if (targeting.error) {
    return {
      available: false,
      reason: targeting.error
    };
  }
  if (!targeting.type) {
    return {
      available: true,
      reason: null
    };
  }
  var normalizedStoreCode = normalizeStoreCode(storeCode);
  if (!normalizedStoreCode) {
    return {
      available: false,
      reason: "Cannot evaluate targeted Published Offer without a current store code"
    };
  }
  var matchesCurrentStore = targeting.storeCodes.includes(normalizedStoreCode);
  var available = targeting.type === "store_whitelist" ? matchesCurrentStore : !matchesCurrentStore;
  return {
    available,
    reason: available ? null : "".concat(targeting.type, " does not allow store ").concat(storeCode)
  };
};
export var isOfferAvailableForStore = function (offer, storeCode) {
  var logger = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : console;
  var availability = getOfferStoreAvailability(offer, storeCode);
  if (!availability.available && logger && typeof logger.warn === "function") {
    logger.warn("Published Offer excluded by store targeting", {
      offerId: offer === null || offer === void 0 ? void 0 : offer.offer_id,
      barcode: offer === null || offer === void 0 ? void 0 : offer.barcode,
      storeCode,
      reason: availability.reason
    });
  }
  return availability.available;
};
export var isCouponCodeAvailableForStore = function (offers, couponCode, storeCode) {
  var logger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : console;
  var normalizedCouponCode = normalizeStoreCode(couponCode);
  var matchingOffer = (offers || []).find(offer => normalizeStoreCode(offer === null || offer === void 0 ? void 0 : offer.barcode) === normalizedCouponCode);

  // Codes which are not Published Offers retain Magento's existing validation path.
  return matchingOffer ? isOfferAvailableForStore(matchingOffer, storeCode, logger) : true;
};
export { parseTargetingMetadata };